import { getSizeFilterConfig } from '../filters/size';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getConditionsFilterConfig } from '../filters/condition';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { Currency } from '../../types/apollo/generated/types.generated';

const fumbalinasSizes: string[] = [
  'Kaftan Dress',
  'Mega',
  'Mini',
  'Mini+Mega',
  'Size 1 (Smaller)',
  'Size 2 (Larger)',
  'One Size',
];

export const fumbalinasShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getBrandDirectFilterConfig(),
    getConditionsFilterConfig(),
    getSizeFilterConfig({
      sizes: fumbalinasSizes,
    }),
  ],
  returnShippingPrice: {
    price: 599,
    currency: Currency.Gbp,
  },
};
